import { Hero } from '../components/Hero'
import { Highlights } from '../components/Highlights'
import { FeaturedProducts } from '../components/FeaturedProducts'
import { LatestPosts } from '../components/LatestPosts'
import { useSeo } from '../hooks/useSeo'
import { SITE_URL, SITE_NAME } from '../config/site'

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_URL,
}

export function Home() {
  useSeo({ path: '/', jsonLd: homeJsonLd })
  return (
    <>
      <Hero />
      <Highlights />
      <FeaturedProducts />
      <LatestPosts />
    </>
  )
}
